import React from 'react';
import { createPortal } from 'react-dom';
import { MdClose, MdLogout, MdWarning } from 'react-icons/md';
import './LogoutModal.css';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content_logoutModal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-logoutModal">
          <div className="modal-icon warning">
            <MdWarning />
          </div>
        </div>
        <div className="modal-body-logoutModal">
          <h3>Confirm Logout</h3>
          <p>Are you sure you want to logout? You will need to sign in again to access your account.</p>
        </div>
        <div className="modal-footer-logoutModal">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            <MdLogout />
            Logout
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutModal;